import axios from "axios";

const api = axios.create({
  withCredentials: true,
  // baseURL: "http://20.62.5.81/",
  // baseURL: "http://127.0.0.1:8000/",
  // baseURL: "http://192.168.1.131:8000/",
  baseURL: "https://percel-api.techtrioz.xyz",
  headers: { "Content-Type": "application/json", Authorization: "" },
  credentials: "include",
});

let refresh = false;
console.log(api);
api.interceptors.request.use((config) => {
  const excludedPaths = ["/auth/login/", "/auth/logout/", "/auth/registration/"];
  
  
  if (excludedPaths.some((path) => config.url?.includes(path))) {
    return config;
  }

  const token = localStorage.getItem("jwt");
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }

  return config;
});


export default api;
